import grades from './SelectList/GradesCarabineros'

// Only existing nominal ranks may supply an exact value. Imported numeric
// references and CPR tariff labels are not hierarchical ranks.
const exactGrades = grades.filter(
  (grade) => grade !== 'Sin definir' && !grade.startsWith('C.P.R.')
)

export const partnerHierarchy = (partner = {}) => ({
  cprGrade:
    partner.cprGrade !== undefined
      ? partner.cprGrade ?? ''
      : partner.officialType === 'CPR' &&
        /^\d+$/.test(String(partner.otherGrade ?? '').trim())
      ? Number(partner.otherGrade)
      : '',
  cprGradeSource: partner.cprGradeSource,
  cprGradePeriod: partner.cprGradePeriod,
  officialType: partner.officialType || '',
  hierarchicalGroupSource: partner.hierarchicalGroupSource,
  hierarchicalGroupPeriod: partner.hierarchicalGroupPeriod,
  hierarchicalGroup: partner.hierarchicalGroup || '',
  hierarchicalGrade:
    partner.hierarchicalGrade !== undefined
      ? partner.hierarchicalGrade || ''
      : exactGrades.includes(partner.grade)
      ? partner.grade
      : ''
})

export const appendHierarchy = (formData, values) => {
  // GetFormData omits empty values; these fields must explicitly allow clearing.
  formData.set('cprGrade', values.cprGrade ?? '')
  formData.set('officialType', values.officialType || '')
  formData.set('hierarchicalGroup', values.hierarchicalGroup || '')
  formData.set('hierarchicalGrade', values.hierarchicalGrade || '')
}

export const cprBandLabel = (band) =>
  ({ 0: 'Grado 0', '1-12': 'Grados 1 a 12', '13+': 'Grados 13 en adelante' }[
    band
  ] || 'Tramo sin definir')
